import dayjs from 'dayjs';

export function demoData() {
  return {
    items: [
      {
        external_id: 263129066,
        product_title: 'Boat Rental',
        quantity: 1,
        start: '2060-10-10T11:00:00.000Z',
        status: 'ok',
      },
    ],
    checkout: false,
    expiresAt: dayjs().add(1, 'minute'),
    leftSeconds: 60,
  };
}
